<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :form-fields="{model: []}"
                  :url="url"
                  :permission="{}"
                  :operate="[]"
                  :buttons="buttons"
                  :searchs="searchs"/>

    <div class="dialog">
      <el-dialog title="选择导出时间"
                 :visible.sync="exportVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('form')"
                 width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px"
                   :model="form" ref="form">
            <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
              <el-select filterable
                         v-model="form.agentId" clearable
                         placeholder="请选择代理"
                         size="medium" class="mr10 mb-10">
                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
              <el-date-picker v-model="form.startTime"
                              placeholder="开始时间"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type='datetime' align="right"
                              size="medium" class="mr10 mb-10"/>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
              <el-date-picker v-model="form.endTime"
                              placeholder="结束时间"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type='datetime' align="right"
                              size="medium" class="mr10 mb-10"/>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="exportVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submit('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import CommonTable from "../../components/CommonTable/CommonTable";
import message from "@/utils/message";

export default {
  name: "UserTeam",
  components: {CommonTable},
  data() {
    return {
      exportVisible:false,
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'sort',
        placeholder: '排序字段',
        type: 'select',
        selectValue: [
          {
            key: "lev1",
            value: 'lev1',
          }, {
            key: "lev2",
            value: 'lev2',
          }, {
            key: "lev3",
            value: 'lev3',
          },{
            key: "lev1RechargeMoney",
            value: '一级充值金额',
          }, {
            key: "lev2RechargeMoney",
            value: '二级充值金额',
          }, {
            key: "lev3RechargeMoney",
            value: '三级充值金额',
          }, {
            key: "rechargeMoney",
            value: '总充值金额',
          }, {
            key: "lev1WithdrawalMoney",
            value: '一级出款金额',
          }, {
            key: "lev2WithdrawalMoney",
            value: '二级出款金额',
          }, {
            key: "lev3WithdrawalMoney",
            value: '三级出款金额',
          }, {
            key: "withdrawalMoney",
            value: '总出款金额',
          }
        ],
      },{
        name: 'order',
        placeholder: '排序顺序',
        type: 'select',
        selectValue: [
          {
            key: "asc",
            value: '正叙',
          },
          {
            key: "desc",
            value: '倒叙',
          }
        ],
      },],
      url: {
        get: '/userTeam/listByCondition',
      },
      tableColumns: [{
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'lev1',
        label: 'lev1',
        show: true,
        width: '',
      },  {
        field: 'lev2',
        label: 'lev2',
        show: true,
        width: '',
      },  {
        field: 'lev3',
        label: 'lev3',
        show: true,
        width: '',
      }, {
        field: 'lev1RechargeMoney',
        label: '一级充值金额',
        show: true,
        width: '',
      }, {
        field: 'lev2RechargeMoney',
        label: '二级充值金额',
        show: true,
        width: '',
      }, {
        field: 'lev3RechargeMoney',
        label: '三级充值金额',
        show: true,
        width: '',
      }, {
        field: 'rechargeMoney',
        label: '总充值金额',
        show: true,
        width: '',
      }, {
        field: 'lev1WithdrawalMoney',
        label: '一级出款金额',
        show: true,
        width: '',
      }, {
        field: 'lev2WithdrawalMoney',
        label: '二级出款金额',
        show: true,
        width: '',
      }, {
        field: 'lev3WithdrawalMoney',
        label: '三级出款金额',
        show: true,
        width: '',
      }, {
        field: 'withdrawalMoney',
        label: '总出款金额',
        show: true,
        width: '',
      }],
    buttons: [{
      icon: 'el-icon-download',
      type: 'warning',
      text: '导出',
      permission: 'capitalStatistics:export',
      click: () => {
        this.tableColumns.some(item => {
          if (item.field == 'agentId') {
            this.agents = item.selectData;
          }
        })
        this.exportVisible = true;
      }
    }]
  }
  },
  methods: {
    //重置表单
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.get({
            url: '/capitalStatistics/export',
            data: this.form,
            confirm: '确定导出Excel？',
            //responseType: 'arraybuffer',
            success: (res) => {
              if (res.code === 0) {
                message.success("记录导出任务正在进行中");
                this.exportVisible = false;
              } else {
                message.error(res.msg);
              }
              /*if (res.code) {
                  message.error(res.msg);
                  return;
              }
              excelDownload(res, "积分记录明细导出.xlsx")
              /!*this.$msgbox({
                  title: '下载地址',
                  message: '下载地址为：' + res.data + '，点击确定跳转下载！'
              }).then(() => {
                  window.open(res.data,"_blank");
              }).catch()*!/
              this.exportVisible = false;*/
            }
          })
        }
      })
    }
  }
}
</script>


<style scoped>

</style>
